import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AlertMessageService } from "./alert.message.service";

@Injectable({ providedIn: "root" })
export class ServiceProvider {
	constructor(
		public router: Router,
		public http: HttpClient,
		private _alertService: AlertMessageService,
	) {}

	public accessDenied(message: string) {
		this.showAlert("error", message);
	}

	public showError(message: string) {
		try {
			if (message != null) message = message.replace("java.lang.RuntimeException:", "");
			if (message != null) message = message.replace("java.lang.IllegalArgumentException:", "");
		} catch (error) {}

		this.showAlert("error", message); // don't self close error messages
	}

	public showErrorSelfClose(message: string) {
		this.showAlert("error", message);
	}

	public showMessage(message: string) {
		this.showAlert("error", message);
	}

	private showAlert(type: string, message: string, selfClose: boolean = true) {
		const alert = {
		  type,
		  message,
		  selfClose,
		};
		this._alertService.apply(alert);
	  }
	
}
